import React from "react";
import { ProjectTableProps } from "./types";
import { ProjectTableRow } from "./ProjectTableRow";
import { TableHeader } from "../../../../components/Table";
import { NoData } from "../../../../components/NoData";

/**
 * Smart and simple project table component
 * Handles different project types with configurable columns and rendering
 */
export const ProjectTable: React.FC<ProjectTableProps> = ({
  data,
  columns,
  onRowClick,
  loading = false,
  emptyMessage = "No data available",
}) => {
  if (loading) {
    return (
      <div className="flex items-center justify-center p-8">
        <div className="text-gray-500">Loading...</div>
      </div>
    );
  }

  if (!data || data.length === 0) {
    return <NoData />;
  }

  const headers = columns.map((col) => col.label);

  return (
    <div className="overflow-auto">
      <table style={{ minWidth: "100%" }}>
        <TableHeader headers={headers} />
        <tbody>
          {data.map((item, index) => (
            <ProjectTableRow
              key={`project-row-${index}`}
              item={item}
              columns={columns}
              onRowClick={onRowClick}
              index={index}
              isLast={index === data.length - 1}
            />
          ))}
        </tbody>
      </table>
    </div>
  );
};
